var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition-group",
    {
      staticClass: "storefinderAccordion",
      attrs: { tag: "div", name: "storefinder-fade" },
    },
    _vm._l(_vm.pageTree, function (parent, i) {
      return _c(
        "StorefinderCollapse",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedRootPages.includes(parent.page.uid),
              expression: "selectedRootPages.includes(parent.page.uid)",
            },
          ],
          key: parent.page.uid,
          ref: "panel",
          refInFor: true,
          attrs: { open: _vm.selectedRootPages.includes(parent.page.uid) },
        },
        [
          _c(
            "span",
            {
              staticClass: "headline--2",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v(_vm._s(parent.page.title))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "storefinderAccordion__categoryList" },
            _vm._l(parent.children, function (child) {
              return _c("fieldset", [
                _c("label", { staticClass: "storefinderAccordion__label" }, [
                  _vm.tag(child)
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedTags,
                            expression: "selectedTags",
                          },
                        ],
                        staticClass: "storefinderAccordion__checkbox",
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: _vm.tag(child).uid,
                          checked: Array.isArray(_vm.selectedTags)
                            ? _vm._i(_vm.selectedTags, _vm.tag(child).uid) > -1
                            : _vm.selectedTags,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = _vm.selectedTags,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = _vm.tag(child).uid,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedTags = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedTags = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedTags = $$c
                              }
                            },
                            _vm.onTagCheckboxChange,
                          ],
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "storefinderAccordion__category" },
                    [_vm._v(_vm._s(child.page.title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "storefinderAccordion__link",
                      attrs: { href: child.page.slug, target: "_blank" },
                    },
                    [_vm._v("→")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(child.children, function (grandChild) {
                    return _c(
                      "li",
                      { staticClass: "storefinderAccordion__bookmarkItem" },
                      [
                        _c(
                          "label",
                          { staticClass: "storefinderAccordion__label" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedPages,
                                  expression: "selectedPages",
                                },
                              ],
                              staticClass: "storefinderAccordion__checkbox",
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: grandChild.page.uid,
                                checked: Array.isArray(_vm.selectedPages)
                                  ? _vm._i(
                                      _vm.selectedPages,
                                      grandChild.page.uid
                                    ) > -1
                                  : _vm.selectedPages,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.selectedPages,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = grandChild.page.uid,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.selectedPages = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.selectedPages = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.selectedPages = $$c
                                    }
                                  },
                                  function ($event) {
                                    return _vm.onBookmarkCheckboxChange(
                                      $event,
                                      child
                                    )
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(grandChild.page.title))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "storefinderAccordion__link",
                                attrs: {
                                  href: grandChild.page.slug,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("→")]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            }),
            0
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }